import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=4cf3eb02"
import script from "./SettingsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports